import revive_payload_client_4sVQNw7RlN from "/srv/app/node_modules/nuxt/dist/app/plugins/revive-payload.client.js";
import unhead_KgADcZ0jPj from "/srv/app/node_modules/nuxt/dist/head/runtime/plugins/unhead.js";
import router_jmwsqit4Rs from "/srv/app/node_modules/nuxt/dist/pages/runtime/plugins/router.js";
import _0_siteConfig_MwZUzHrRNP from "/srv/app/node_modules/nuxt-site-config/dist/runtime/nuxt/plugins/0.siteConfig.js";
import payload_client_yVLowv6hDl from "/srv/app/node_modules/nuxt/dist/app/plugins/payload.client.js";
import navigation_repaint_client_bs2bWDGRIE from "/srv/app/node_modules/nuxt/dist/app/plugins/navigation-repaint.client.js";
import check_outdated_build_client_8vK7RkfGxZ from "/srv/app/node_modules/nuxt/dist/app/plugins/check-outdated-build.client.js";
import chunk_reload_client_UciE0i6zes from "/srv/app/node_modules/nuxt/dist/app/plugins/chunk-reload.client.js";
import components_plugin_KR1HBZs4kY from "/srv/app/.nuxt/components.plugin.mjs";
import prefetch_client_5tzzN0oIVL from "/srv/app/node_modules/nuxt/dist/pages/runtime/plugins/prefetch.client.js";
import sentry_client_VdOeuw25Mb from "/srv/app/node_modules/@sentry/nuxt/build/module/runtime/plugins/sentry.client.js";
import sentry_client_config_o34nk2sJbg from "/srv/app/.nuxt/sentry-client-config.mjs";
import plugin_eTVJQYlCmx from "/srv/app/node_modules/@nuxtjs/apollo/dist/runtime/plugin.mjs";
import plugin_tbFNToZNim from "/srv/app/node_modules/@zadigetvoltaire/nuxt-gtm/dist/runtime/plugin.mjs";
import ApolloPreview_SnjR6HXRX5 from "/srv/app/plugins/ApolloPreview.js";
import apiClient_0jb6kvzJeH from "/srv/app/plugins/apiClient.js";
import appleLogin_client_ooN9mL67AB from "/srv/app/plugins/appleLogin.client.js";
import breakpoints_AXORAsvJyN from "/srv/app/plugins/breakpoints.js";
import common_YciHauaUFF from "/srv/app/plugins/common.ts";
import globalTranslation_y1P9OdFhnl from "/srv/app/plugins/globalTranslation.ts";
export default [
  revive_payload_client_4sVQNw7RlN,
  unhead_KgADcZ0jPj,
  router_jmwsqit4Rs,
  _0_siteConfig_MwZUzHrRNP,
  payload_client_yVLowv6hDl,
  navigation_repaint_client_bs2bWDGRIE,
  check_outdated_build_client_8vK7RkfGxZ,
  chunk_reload_client_UciE0i6zes,
  components_plugin_KR1HBZs4kY,
  prefetch_client_5tzzN0oIVL,
  sentry_client_VdOeuw25Mb,
  sentry_client_config_o34nk2sJbg,
  plugin_eTVJQYlCmx,
  plugin_tbFNToZNim,
  ApolloPreview_SnjR6HXRX5,
  apiClient_0jb6kvzJeH,
  appleLogin_client_ooN9mL67AB,
  breakpoints_AXORAsvJyN,
  common_YciHauaUFF,
  globalTranslation_y1P9OdFhnl
]